import { useState, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import UsersPage from "./UsersPage";
import PermissionsPage from "./PermissionsPage";

// ── PRIORIDADES ────────────────────────────────────────────
const C = {
  baixa:   { bg:"bg-emerald-100", text:"text-emerald-700", border:"border-emerald-200", dot:"bg-emerald-400" },
  media:   { bg:"bg-yellow-100",  text:"text-yellow-700",  border:"border-yellow-200",  dot:"bg-yellow-400"  },
  alta:    { bg:"bg-orange-100",  text:"text-orange-700",  border:"border-orange-200",  dot:"bg-orange-400"  },
  urgente: { bg:"bg-red-100",     text:"text-red-700",     border:"border-red-200",     dot:"bg-red-500"     },
};
const PRIORITIES = {
  baixa:   { label:"Baixa",   ...C.baixa },
  media:   { label:"Média",   ...C.media },
  alta:    { label:"Alta",    ...C.alta  },
  urgente: { label:"Urgente", ...C.urgente },
};

// ── 23 STATUS EM 4 GRUPOS ──────────────────────────────────
const STATUSES = {
  aguardando_capitar:  { label:"Aguardando Capitar",  cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  falta_editar_video:  { label:"Falta Editar Vídeo",  cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  falta_postar:        { label:"FALTA POSTAR",         cls:"bg-red-600 text-white font-bold",    dot:"bg-red-600",     group:"pendencia" },
  falta_legenda:       { label:"Falta Legenda",        cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  falta_briefing:      { label:"Falta Briefing",       cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  urgente:             { label:"URGENTE 🔥",            cls:"bg-red-600 text-white font-bold",    dot:"bg-red-600",     group:"pendencia" },
  sem_copy:            { label:"Sem Copy",             cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  falta_arte:          { label:"Falta Arte",           cls:"bg-red-700 text-white",              dot:"bg-red-700",     group:"pendencia" },
  legenda_pronta:      { label:"Legenda Pronta",       cls:"bg-teal-600 text-white",             dot:"bg-teal-600",    group:"andamento" },
  video_pronto:        { label:"Vídeo Pronto",         cls:"bg-teal-600 text-white",             dot:"bg-teal-600",    group:"andamento" },
  copy_pronta:         { label:"Copy Pronta",          cls:"bg-teal-600 text-white",             dot:"bg-teal-600",    group:"andamento" },
  arte_pronta:         { label:"Arte Pronta",          cls:"bg-teal-600 text-white",             dot:"bg-teal-600",    group:"andamento" },
  postado:             { label:"Postado",              cls:"bg-teal-600 text-white",             dot:"bg-teal-600",    group:"andamento" },
  terceiro_produzindo: { label:"Terceiro Produzindo",  cls:"bg-amber-500 text-white",            dot:"bg-amber-500",   group:"revisao"   },
  falta_aprovar:       { label:"Falta Aprovar",        cls:"bg-amber-500 text-white",            dot:"bg-amber-500",   group:"revisao"   },
  refazer_arte:        { label:"Refazer Arte",         cls:"bg-amber-600 text-white",            dot:"bg-amber-600",   group:"revisao"   },
  revisao:             { label:"REVISÃO",              cls:"bg-violet-600 text-white font-bold", dot:"bg-violet-600",  group:"revisao"   },
  refazer_video:       { label:"Refazer Video",        cls:"bg-amber-600 text-white",            dot:"bg-amber-600",   group:"revisao"   },
  post_programado:     { label:"Post Programado",      cls:"bg-emerald-600 text-white",          dot:"bg-emerald-600", group:"concluido" },
  video_aprovado:      { label:"Vídeo Aprovado",       cls:"bg-emerald-600 text-white",          dot:"bg-emerald-600", group:"concluido" },
  arte_aprovada:       { label:"Arte Aprovada",        cls:"bg-emerald-600 text-white",          dot:"bg-emerald-600", group:"concluido" },
  aprovado:            { label:"Aprovado",             cls:"bg-emerald-600 text-white",          dot:"bg-emerald-600", group:"concluido" },
  pronto:              { label:"Pronto",               cls:"bg-emerald-600 text-white",          dot:"bg-emerald-600", group:"concluido" },
  arquivada:           { label:"Arquivada",            cls:"bg-slate-100 text-slate-500",        dot:"bg-slate-400",   group:"arquivo"   },
};
const STATUS_GROUPS = [
  { id:"pendencia", label:"🔴 Pendências" },
  { id:"andamento", label:"🔵 Em Andamento" },
  { id:"revisao",   label:"🟡 Revisão" },
  { id:"concluido", label:"🟢 Concluídos" },
];

// ── PLATAFORMAS ROTINAS ────────────────────────────────────
const PLATFORMS = [
  { id:"meta", label:"META", icon:"🔵", fields:[
    { id:"saldo",     label:"Saldo",     opts:[{id:"gerou",label:"Gerou (enviou)"},{id:"ainda_tem",label:"Ainda tem"},{id:"aguardando_pag",label:"Aguardando pagamento"}] },
    { id:"resultado", label:"Resultado", opts:[{id:"esperado",label:"Dentro do esperado"},{id:"fraco",label:"Fraco"},{id:"boa",label:"Campanha Boa"}] },
    { id:"criativo",  label:"Criativo",  opts:[{id:"trocou",label:"Trocou"},{id:"manteve",label:"Manteve"},{id:"solicitou",label:"Solicitou novo"}] },
  ]},
  { id:"gads", label:"Google Ads", icon:"🟢", fields:[
    { id:"saldo",     label:"Saldo",     opts:[{id:"gerou",label:"Gerou (enviou)"},{id:"ainda_tem",label:"Ainda tem"},{id:"aguardando_pag",label:"Aguardando pagamento"}] },
    { id:"resultado", label:"Resultado", opts:[{id:"esperado",label:"Dentro do esperado"},{id:"fraco",label:"Fraco"},{id:"boa",label:"Campanha Boa"}] },
    { id:"anuncio",   label:"Anúncio",   opts:[{id:"manteve",label:"Manteve"},{id:"trocou_palavras",label:"Trocou palavras"},{id:"substituiu",label:"Substituiu"}] },
  ]},
];
const FIELD_COLORS = {
  gerou:          "bg-emerald-100 text-emerald-700 border-emerald-300",
  ainda_tem:      "bg-yellow-100 text-yellow-700 border-yellow-300",
  aguardando_pag: "bg-purple-100 text-purple-700 border-purple-300",
  esperado:       "bg-emerald-100 text-emerald-700 border-emerald-300",
  fraco:          "bg-red-100 text-red-700 border-red-300",
  boa:            "bg-blue-100 text-blue-700 border-blue-300",
  trocou:         "bg-orange-100 text-orange-700 border-orange-300",
  manteve:        "bg-slate-100 text-slate-600 border-slate-300",
  solicitou:      "bg-violet-100 text-violet-700 border-violet-300",
  trocou_palavras:"bg-orange-100 text-orange-700 border-orange-300",
  substituiu:     "bg-pink-100 text-pink-700 border-pink-300",
};

// ── HELPERS ────────────────────────────────────────────────
// converte YYYY-MM-DD → DD/MM/YYYY para exibição (armazenamento interno continua YYYY-MM-DD)
function fmtDate(dateStr) {
  if(!dateStr) return "—";
  const [y,m,d]=dateStr.slice(0,10).split("-");
  return `${d}/${m}/${y}`;
}
function deadlineLv(dateStr) {
  if (!dateStr) return null;
  const t=new Date(); t.setHours(0,0,0,0);
  const d=new Date(dateStr); d.setHours(0,0,0,0);
  const diff=Math.round((d-t)/86400000);
  if (diff<0)  return {...C.urgente,tag:"Vencido"};
  if (diff<=2) return {...C.urgente,tag:`${diff}d`};
  if (diff<=4) return {...C.alta,   tag:`${diff}d`};
  if (diff<=5) return {...C.media,  tag:`${diff}d`};
  return           {...C.baixa,  tag:`${diff}d`};
}
function getClientPlatforms(client){
  if(!client.platforms||client.platforms.length===0) return PLATFORMS;
  return PLATFORMS.filter(p=>client.platforms.includes(p.id));
}
function clientDayCount(checks,client,date){
  const cc=checks?.[date]?.[client.id]||{};
  const pls=getClientPlatforms(client);
  let total=0,done=0;
  for(const pl of pls){
    const plData=cc[pl.id]||{};
    total+=pl.fields.length;
    // inativo ou aguardando pagamento → plataforma 100% concluída
    if(plData.inactive||plData.saldo==="aguardando_pag") done+=pl.fields.length;
    else done+=pl.fields.filter(f=>plData[f.id]).length;
  }
  return {done,total};
}
function dayProgress(checks,clients,date){
  let total=0,done=0;
  for(const c of clients){const r=clientDayCount(checks,c,date);total+=r.total;done+=r.done;}
  return {done,total,pct:total?done/total:0};
}
// progresso isolado por plataforma (META e Google Ads separados)
function platformDayProgress(checks,clients,date,platformId){
  const pl=PLATFORMS.find(p=>p.id===platformId);
  if(!pl) return {done:0,total:0,pct:0};
  let total=0,done=0;
  for(const c of clients){
    if(!getClientPlatforms(c).some(p=>p.id===platformId)) continue;
    const plData=checks?.[date]?.[c.id]?.[platformId]||{};
    total+=pl.fields.length;
    if(plData.inactive||plData.saldo==="aguardando_pag") done+=pl.fields.length;
    else done+=pl.fields.filter(f=>plData[f.id]).length;
  }
  return {done,total,pct:total?done/total:0};
}
function overallApproval(fileApprovals={}, files=[]) {
  if(!files.length) return null;
  const vals=files.map(f=>fileApprovals[f.id]?.status||null);
  if(vals.every(v=>v==="aprovado")) return "aprovado";
  if(vals.some(v=>v==="revisao")) return "revisao";
  return null;
}

// ── LINK HELPERS ───────────────────────────────────────────
const SIX_MONTHS=6*30*24*60*60*1000;
const DEFAULT_FORMATS=[
  "Artigo 1200 x 627px","Feed LinkedIn","Estático Anúncio","Vídeo Anúncio",
  "Vídeo Reels / Shorts","Capa Reels / Shorts","Feed Instagram","Carrossel",
  "Story","Capa Vídeo Youtube","Vídeo YT","Banner Site","Identidade Visual","Apresentação",
];
const driveThumb=url=>{
  if(!url) return null;
  for(const p of [/\/file\/d\/([a-zA-Z0-9_-]+)/,/[?&]id=([a-zA-Z0-9_-]+)/,/\/d\/([a-zA-Z0-9_-]+)/]){
    const m=url.match(p); if(m) return `https://drive.google.com/thumbnail?id=${m[1]}&sz=w320-h200`;
  }
  return null;
};
const encodeForLink=demand=>{
  const p={id:demand.id,title:demand.title,files:(demand.files||[]).map(f=>({id:f.id,name:f.name,url:f.url}))};
  return btoa(unescape(encodeURIComponent(JSON.stringify(p))));
};
const decodeFromLink=enc=>{try{return JSON.parse(decodeURIComponent(escape(atob(enc))));}catch{return null;}};
const genLink=demand=>{
  const base=window.location.origin+"/app";
  return `${base}#ap:${encodeForLink(demand)}`;
};

// ── SEED (estado inicial vazio — nunca sobrescreve dados reais) ────────────
const SEED={
  employees:[],
  clients:[],
  projects:[],
  formats:DEFAULT_FORMATS,
  checks:{},
  history:[],
  demands:[],
};

// mapa de status antigos para novos (migração de agpro_v6)
const STATUS_MIGRATION={a_fazer:"falta_arte",em_andamento:"copy_pronta",em_aprovacao:"falta_aprovar",concluido:"aprovado"};

// ── ATOMS ──────────────────────────────────────────────────
function Avatar({name,size="sm"}) {
  const i=name?.split(" ").map(n=>n[0]).join("").slice(0,2)||"?";
  const sz=size==="sm"?"w-7 h-7 text-xs":"w-9 h-9 text-sm";
  const cols=["bg-indigo-100 text-indigo-700","bg-pink-100 text-pink-700","bg-teal-100 text-teal-700","bg-amber-100 text-amber-700"];
  return <div className={`${sz} ${cols[(name?.charCodeAt(0)||0)%cols.length]} rounded-full flex items-center justify-center font-bold flex-shrink-0`}>{i}</div>;
}
function PBadge({value}) {
  const p=PRIORITIES[value]; if(!p) return null;
  return <span className={`text-xs px-2 py-0.5 rounded-full font-medium border ${p.bg} ${p.text} ${p.border}`}>{p.label}</span>;
}
function SBadge({value}) {
  const s=STATUSES[value]; if(!s) return null;
  return <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${s.cls}`}>{s.label}</span>;
}
function DLine({value}) {
  const lv=deadlineLv(value);
  if(!value) return <span className="text-gray-400 text-xs">—</span>;
  return <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${lv.bg} ${lv.text}`}>{fmtDate(value)} <span className="opacity-60">({lv.tag})</span></span>;
}
function InlinePriority({value,onChange}) {
  const [open,setOpen]=useState(false); const ref=useRef();
  useEffect(()=>{const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false)};document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);},[]);
  return (
    <div className="relative" ref={ref}>
      <button onClick={()=>setOpen(!open)} className="flex items-center gap-1 hover:opacity-80 transition-opacity" title="Clique para editar urgência">
        <PBadge value={value}/><span className="text-indigo-300 text-xs">✏️</span>
      </button>
      {open&&<div className="absolute z-30 top-7 left-0 bg-white border rounded-xl shadow-xl p-1.5 min-w-[110px] space-y-1">
        {Object.entries(PRIORITIES).map(([k,v])=>(
          <button key={k} onClick={()=>{onChange(k);setOpen(false);}} className={`w-full text-left px-2 py-1 rounded-lg ${value===k?"ring-2 ring-indigo-300":""}`}>
            <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${v.bg} ${v.text} ${v.border}`}>{v.label}</span>
          </button>
        ))}
      </div>}
    </div>
  );
}
function FileThumbnail({url,name,size="md"}) {
  const [err,setErr]=useState(false);
  const thumb=driveThumb(url);
  const h=size==="sm"?"h-20":"h-32";
  return (
    <div className="border rounded-xl overflow-hidden flex-shrink-0">
      {thumb&&!err
        ?<img src={thumb} alt={name} className={`w-full ${h} object-cover bg-slate-100`} onError={()=>setErr(true)}/>
        :<div className={`w-full ${h} bg-slate-100 flex flex-col items-center justify-center gap-1`}><span className="text-2xl">📄</span><span className="text-xs text-gray-400 px-2 text-center truncate w-full">{name}</span></div>}
      <a href={url} target="_blank" rel="noopener noreferrer" className="block text-center text-xs text-indigo-600 hover:bg-indigo-50 py-1.5 border-t transition-colors truncate px-2">{name} →</a>
    </div>
  );
}

// ── APPROVAL CLIENT PAGE ───────────────────────────────────
function ClientFileCard({file,savedApproval,onSubmit}) {
  const [comment,setComment]=useState("");
  const [done,setDone]=useState(savedApproval?.status||null);
  const [showInput,setShowInput]=useState(false);
  const [imgErr,setImgErr]=useState(false);
  const thumb=driveThumb(file.url);
  const submit=async status=>{
    if(status==="revisao"&&!comment.trim())return;
    await onSubmit(file.id,status,comment);
    setDone(status); setShowInput(false);
  };
  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-slate-100">
      <div className="bg-slate-100 w-full h-52 flex items-center justify-center relative overflow-hidden">
        {thumb&&!imgErr
          ?<img src={thumb} alt={file.name} className="w-full h-full object-cover" onError={()=>setImgErr(true)}/>
          :<div className="flex flex-col items-center gap-2 text-slate-400"><span className="text-5xl">📄</span><span className="text-sm font-medium">{file.name}</span></div>}
        <a href={file.url} target="_blank" rel="noopener noreferrer"
          className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 hover:bg-opacity-70 text-white text-xs py-2 text-center transition-all opacity-0 hover:opacity-100 font-medium">
          Abrir arquivo completo ↗
        </a>
      </div>
      <div className="px-4 pt-3 pb-1 flex items-center justify-between">
        <p className="text-sm font-semibold text-gray-800 truncate flex-1">{file.name}</p>
        <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-xs text-indigo-500 hover:text-indigo-700 font-medium flex-shrink-0 ml-2">↗ Abrir</a>
      </div>
      <div className="px-4 pb-4 pt-2">
        {done
          ?<div className={`rounded-xl p-3 text-sm font-semibold text-center ${done==="aprovado"?"bg-emerald-50 text-emerald-700 border border-emerald-200":"bg-orange-50 text-orange-700 border border-orange-200"}`}>
            {done==="aprovado"?"✅ Aprovado":"🔄 Revisão solicitada"}
            {savedApproval?.comment&&<p className="text-xs font-normal mt-1 opacity-80">"{savedApproval.comment}"</p>}
          </div>
          :showInput
            ?<div className="space-y-2">
              <textarea className="w-full border border-orange-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none bg-orange-50"
                rows={3} value={comment} onChange={e=>setComment(e.target.value)} placeholder="Descreva o que precisa ser ajustado..." autoFocus/>
              <div className="flex gap-2">
                <button onClick={()=>submit("revisao")} disabled={!comment.trim()}
                  className={`flex-1 py-2 rounded-xl text-sm font-bold transition-colors ${comment.trim()?"bg-orange-500 hover:bg-orange-600 text-white":"bg-gray-100 text-gray-300 cursor-not-allowed"}`}>
                  Confirmar Revisão
                </button>
                <button onClick={()=>setShowInput(false)} className="px-4 py-2 text-sm border rounded-xl hover:bg-gray-50 text-gray-500">Cancelar</button>
              </div>
            </div>
            :<div className="flex gap-2">
              <button onClick={()=>submit("aprovado")} className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white py-2.5 rounded-xl text-sm font-bold transition-colors shadow-sm">✅ Aprovar</button>
              <button onClick={()=>setShowInput(true)} className="flex-1 bg-slate-100 hover:bg-orange-100 text-slate-600 hover:text-orange-700 py-2.5 rounded-xl text-sm font-bold transition-colors">🔄 Pedir Revisão</button>
            </div>}
      </div>
    </div>
  );
}

function ApprovalPage({encoded}) {
  const [demand,setDemand]=useState(null);
  const [fileApprovals,setFileApprovals]=useState({});
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    const decoded=decodeFromLink(encoded);
    setDemand(decoded);
    if(decoded){
      (async()=>{
        try{const res=await window.storage.get(`ap_result:${decoded.id}`,true);if(res)setFileApprovals(JSON.parse(res.value)||{});}catch{}
        setLoading(false);
      })();
    }else setLoading(false);
  },[encoded]);
  const submitFile=async(fileId,status,comment)=>{
    const updated={...fileApprovals,[fileId]:{status,comment,ts:Date.now()}};
    setFileApprovals(updated);
    try{await window.storage.set(`ap_result:${demand.id}`,JSON.stringify(updated),true);}catch{}
  };
  if(loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><p className="text-gray-400 animate-pulse text-sm">Carregando...</p></div>;
  if(!demand) return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4"><div className="bg-white p-10 rounded-2xl shadow text-center max-w-xs"><p className="text-4xl mb-3">🔍</p><p className="text-gray-500 text-sm">Este link é inválido ou já expirou.</p></div></div>;
  const files=demand.files||[];
  const handled=files.filter(f=>fileApprovals[f.id]?.status).length;
  const allDone=handled===files.length&&files.length>0;
  return (
    <div className="min-h-screen bg-slate-50" style={{fontFamily:"system-ui,sans-serif"}}>
      <div className="bg-white border-b px-6 py-4 flex items-center justify-between max-w-3xl mx-auto">
        <div><p className="text-xs text-gray-400 mb-0.5">Solicitação de aprovação</p><h1 className="text-base font-bold text-gray-800">{demand.title}</h1></div>
        {files.length>0&&<span className="text-xs bg-slate-100 text-slate-500 px-3 py-1 rounded-full font-medium">{handled}/{files.length} revisado{files.length!==1?"s":""}</span>}
      </div>
      <div className="max-w-3xl mx-auto p-5 space-y-5">
        {!allDone&&files.length>0&&<div className="bg-indigo-50 border border-indigo-100 rounded-xl px-4 py-3 text-sm text-indigo-700">Revise cada arquivo abaixo e clique em <strong>Aprovar</strong> ou <strong>Pedir Revisão</strong>.</div>}
        {files.length===0&&<div className="bg-white rounded-2xl border p-16 text-center"><p className="text-3xl mb-2">📭</p><p className="text-gray-400 text-sm">Nenhum arquivo disponível para aprovação.</p></div>}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {files.map(f=><ClientFileCard key={f.id} file={f} savedApproval={fileApprovals[f.id]} onSubmit={submitFile}/>)}
        </div>
        {allDone&&<div className="bg-emerald-500 text-white rounded-2xl p-6 text-center shadow-md"><p className="text-2xl mb-1">🎉</p><p className="font-bold text-base">Tudo revisado, obrigado!</p><p className="text-emerald-100 text-sm mt-1">Suas respostas foram registradas. A equipe entrará em contato em breve.</p></div>}
        <p className="text-center text-xs text-gray-300 pb-4">Esta página é exclusiva para aprovação de materiais.</p>
      </div>
    </div>
  );
}

// ── AGENCY FILE ROW ────────────────────────────────────────
function AgencyFileRow({file,approval,onApprove,onRevision}) {
  const [comment,setComment]=useState("");
  const [showInput,setShowInput]=useState(false);
  return (
    <div className="flex gap-3 items-start border rounded-xl p-3">
      <FileThumbnail url={file.url} name={file.name} size="sm"/>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-gray-700 mb-1 truncate">{file.name}</p>
        {approval?.status
          ?<div className={`text-xs p-1.5 rounded-lg font-medium ${approval.status==="aprovado"?"bg-emerald-50 text-emerald-700":"bg-orange-50 text-orange-700"}`}>
            {approval.status==="aprovado"?"✅ Aprovado pelo cliente":"🔄 Revisão"}{approval.comment?`: ${approval.comment}`:""}
          </div>
          :showInput
            ?<div className="space-y-1.5">
              <textarea className="w-full border rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none" rows={2}
                value={comment} onChange={e=>setComment(e.target.value)} placeholder="Motivo da revisão..."/>
              <div className="flex gap-1.5">
                <button onClick={()=>{onRevision(file.id,comment);setShowInput(false);}} className="flex-1 bg-orange-500 hover:bg-orange-600 text-white text-xs py-1 rounded-lg font-medium">Confirmar</button>
                <button onClick={()=>setShowInput(false)} className="text-xs px-2 py-1 border rounded-lg hover:bg-gray-50">Cancelar</button>
              </div>
            </div>
            :<div className="flex gap-1.5">
              <button onClick={()=>onApprove(file.id)} className="text-xs bg-emerald-100 hover:bg-emerald-200 text-emerald-700 px-2 py-1 rounded-lg font-medium transition-colors">✅ Aprovar</button>
              <button onClick={()=>setShowInput(true)} className="text-xs bg-orange-100 hover:bg-orange-200 text-orange-700 px-2 py-1 rounded-lg font-medium transition-colors">🔄 Revisão</button>
            </div>}
      </div>
    </div>
  );
}

function ApprovalCard({d,emp,cli,doApproval,shareApproval,copiedLink}) {
  const ov=overallApproval(d.fileApprovals,d.files);
  return (
    <div className="bg-white rounded-xl border shadow-sm p-5">
      <div className="flex items-start justify-between mb-3">
        <div><h3 className="font-semibold text-gray-800">{d.title}</h3><p className="text-sm text-gray-500 mt-0.5">{d.description}</p></div>
        <PBadge value={d.priority}/>
      </div>
      <div className="flex flex-wrap gap-3 text-xs text-gray-500 mb-4">
        <span className="flex items-center gap-1.5"><Avatar name={emp(d.assignedTo)?.name}/>{emp(d.assignedTo)?.name||"—"}</span>
        <span>🏢 {cli(d.clientId)?.name||"—"}</span>
        <span>🗂 {d.format||"—"}</span>
        <DLine value={d.deadline}/>
        <span className="ml-auto font-medium text-gray-600">{(d.files||[]).length} arquivo{(d.files||[]).length!==1?"s":""}</span>
      </div>
      <div className="flex items-center gap-2 mb-4">
        <input readOnly value={genLink(d)} className="flex-1 text-xs bg-slate-50 border rounded-lg px-2 py-1.5 text-gray-500 truncate"/>
        <button onClick={()=>shareApproval(d)} className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-colors whitespace-nowrap ${copiedLink[d.id]?"bg-emerald-100 text-emerald-700":"bg-indigo-100 text-indigo-700 hover:bg-indigo-200"}`}>
          {copiedLink[d.id]?"✅ Copiado!":"🔗 Copiar link"}
        </button>
      </div>
      {(d.files||[]).length===0
        ?<p className="text-xs text-gray-400 italic mb-3">Nenhum arquivo anexado. Edite a demanda para adicionar arquivos.</p>
        :<div className="grid grid-cols-1 gap-2 mb-4 sm:grid-cols-2">
          {(d.files||[]).map(f=>(
            <AgencyFileRow key={f.id} file={f} approval={d.fileApprovals?.[f.id]}
              onApprove={fid=>doApproval(d.id,"aprovado","",fid)}
              onRevision={(fid,c)=>doApproval(d.id,"revisao",c,fid)}/>
          ))}
        </div>}
      {ov==="aprovado"&&<div className="p-2.5 bg-emerald-50 text-emerald-700 rounded-lg text-xs font-semibold text-center">✅ Todos os arquivos aprovados — demanda concluída!</div>}
      {ov==="revisao"&&<div className="p-2.5 bg-orange-50 text-orange-700 rounded-lg text-xs font-semibold text-center">🔄 Há arquivos com revisão solicitada.</div>}
    </div>
  );
}

// ── DEMAND DETAIL MODAL ────────────────────────────────────
function DemandDetail({d,emp,cli,proj,onEdit,onDelete,onArchive,onClose}) {
  const [imgErrs,setImgErrs]=useState({});
  const files=d.files||[]; const fa=d.fileApprovals||{};
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center p-4 bg-black bg-opacity-40" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={e=>e.stopPropagation()}>
        <div className="px-6 py-4 border-b flex items-start justify-between sticky top-0 bg-white rounded-t-2xl z-10">
          <div className="flex-1 pr-4">
            <div className="flex items-center gap-2 flex-wrap mb-1">
              <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">{d.format||"—"}</span>
              <PBadge value={d.priority}/><SBadge value={d.status}/>
            </div>
            <h2 className="font-bold text-gray-800 text-lg leading-tight">{d.title}</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0 text-xl">✕</button>
        </div>
        <div className="p-6 space-y-5">
          <div className="grid grid-cols-2 gap-3">
            {[
              {label:"Responsável",value:<div className="flex items-center gap-1.5"><Avatar name={emp(d.assignedTo)?.name}/><span>{emp(d.assignedTo)?.name||"—"}</span></div>},
              {label:"Cliente",value:cli(d.clientId)?.name||"—"},
              {label:"Projeto",value:proj(d.projectId)?.name||"—"},
              {label:"Prazo",value:<DLine value={d.deadline}/>},
            ].map((item,i)=>(
              <div key={i} className="bg-slate-50 rounded-xl px-4 py-3">
                <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1">{item.label}</p>
                <div className="text-sm font-medium text-gray-700">{item.value}</div>
              </div>
            ))}
          </div>
          {(d.description||(d.descImages||[]).length>0)&&<div>
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-2">Descrição</p>
            {d.description&&<div className="bg-slate-50 rounded-xl px-4 py-3 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap mb-2">{d.description}</div>}
            {(d.descImages||[]).length>0&&(
              <div className="flex flex-wrap gap-2">
                {(d.descImages||[]).map(img=>(
                  <div key={img.id} className="relative group">
                    <img src={img.url} alt={img.name||"imagem"} className="h-32 w-auto rounded-xl border object-cover"/>
                    <div className="absolute inset-0 bg-black/40 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                      <a href={img.url} target="_blank" rel="noopener noreferrer"
                        title="Abrir em nova aba" className="w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center text-gray-700 text-sm">
                        ↗
                      </a>
                      <a href={img.url} download={img.name||`imagem-${img.id}.jpg`}
                        title="Baixar" className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center text-white text-sm">
                        ⬇
                      </a>
                    </div>
                    {img.name&&<p className="text-[10px] text-gray-400 truncate max-w-[120px] mt-1 text-center">{img.name}</p>}
                  </div>
                ))}
              </div>
            )}
          </div>}
          {files.length>0&&<div>
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-3">Arquivos ({files.length})</p>
            <div className="grid grid-cols-2 gap-3">
              {files.map(f=>{
                const thumb=driveThumb(f.url); const ap=fa[f.id];
                return (
                  <div key={f.id} className="border rounded-xl overflow-hidden">
                    <div className="bg-slate-100 h-36 relative flex items-center justify-center overflow-hidden">
                      {thumb&&!imgErrs[f.id]
                        ?<img src={thumb} alt={f.name} className="w-full h-full object-cover" onError={()=>setImgErrs(p=>({...p,[f.id]:true}))}/>
                        :<div className="flex flex-col items-center gap-1 text-slate-400"><span className="text-3xl">📄</span><span className="text-xs text-center px-2">{f.name}</span></div>}
                    </div>
                    <div className="px-3 py-2">
                      <a href={f.url} target="_blank" rel="noopener noreferrer" className="text-xs text-indigo-600 hover:text-indigo-800 font-medium block truncate mb-1.5">{f.name} ↗</a>
                      {ap?.status
                        ?<span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${ap.status==="aprovado"?"bg-emerald-100 text-emerald-700":"bg-orange-100 text-orange-700"}`}>
                          {ap.status==="aprovado"?"✅ Aprovado":`🔄 Revisão${ap.comment?`: ${ap.comment}`:""}`}
                        </span>
                        :<span className="text-xs text-gray-400 italic">Aguardando aprovação</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>}
          <div className="flex gap-2 pt-2 border-t flex-wrap">
            <button onClick={()=>{onEdit(d);onClose();}} className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium">✏️ Editar</button>
            <button onClick={()=>{onArchive(d.id);onClose();}} className="bg-amber-100 hover:bg-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">🗂 Arquivar</button>
            <button onClick={()=>{onDelete(d.id);onClose();}} className="bg-red-100 hover:bg-red-200 text-red-600 px-4 py-2 rounded-lg text-sm font-medium">🗑 Excluir</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── TABLE (clicável → DemandDetail) ───────────────────────
function Table({demands,emp,cli,proj,heads,onEdit,onDelete,onArchive,onApproval,renderPriority}) {
  const [openId,setOpenId]=useState(null);
  const openDemand=demands.find(d=>d.id===openId);
  if(!demands.length) return <div className="p-10 text-center text-gray-400 text-sm">Nenhuma demanda.</div>;
  return (
    <>
      {openDemand&&(
        <DemandDetail d={openDemand} emp={emp} cli={cli} proj={proj}
          onEdit={onEdit} onDelete={onDelete} onArchive={onArchive}
          onClose={()=>setOpenId(null)}/>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 text-left text-xs text-gray-500 uppercase tracking-wide">
            {heads.map((h,i)=><th key={i} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody className="divide-y divide-gray-100">
            {demands.map(d=>(
              <tr key={d.id} className="hover:bg-indigo-50 transition-colors cursor-pointer group" onClick={()=>setOpenId(d.id)}>
                <td className="px-4 py-3 max-w-[160px]">
                  <p className="font-medium text-gray-800 text-xs">{d.title}</p>
                  {d.description&&<p className="text-xs text-gray-400 truncate mt-0.5">{d.description}</p>}
                </td>
                <td className="px-4 py-3"><span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full whitespace-nowrap">{d.format||"—"}</span></td>
                <td className="px-4 py-3"><div className="flex items-center gap-1.5"><Avatar name={emp(d.assignedTo)?.name}/><span className="text-xs text-gray-600 whitespace-nowrap">{emp(d.assignedTo)?.name||"—"}</span></div></td>
                <td className="px-4 py-3"><p className="text-xs text-gray-700 whitespace-nowrap">{cli(d.clientId)?.name||"—"}</p><p className="text-xs text-gray-400">{proj(d.projectId)?.name||"—"}</p></td>
                <td className="px-4 py-3 whitespace-nowrap"><DLine value={d.deadline}/></td>
                <td className="px-4 py-3 whitespace-nowrap" onClick={e=>e.stopPropagation()}>{renderPriority(d)}</td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <div className="flex flex-col gap-0.5">
                    <SBadge value={d.status}/>
                    {(d.files||[]).length>0&&<span className="text-xs text-gray-400">{(d.files||[]).length} arquivo{(d.files||[]).length!==1?"s":""}</span>}
                  </div>
                </td>
                <td className="px-4 py-3" onClick={e=>e.stopPropagation()}>
                  <div className="flex gap-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                    <button onClick={()=>onEdit(d)} className="text-indigo-500 hover:text-indigo-700 text-xs font-medium">Editar</button>
                    {d.status==="falta_aprovar"&&<button onClick={()=>onApproval(d)} className="text-violet-500 hover:text-violet-700 text-xs font-medium">Aprovar</button>}
                    <button onClick={()=>onArchive(d.id)} className="text-amber-500 hover:text-amber-700 text-xs font-medium">Arquivar</button>
                    <button onClick={()=>onDelete(d.id)} className="text-red-400 hover:text-red-600 text-xs font-medium">✕</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ── OBS FIELD (salva ao sair do campo) ─────────────────────
function ObsField({value,onSave}) {
  const [v,setV]=useState(value||"");
  useEffect(()=>setV(value||""),[value]);
  return (
    <textarea
      className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs resize-none focus:outline-none focus:ring-2 focus:ring-indigo-200 text-gray-600 placeholder-gray-300 bg-slate-50"
      rows={2} value={v} onChange={e=>setV(e.target.value)} onBlur={()=>onSave(v)}
      placeholder="Observações do dia para este cliente..."/>
  );
}

// ── ROTINAS ────────────────────────────────────────────────
function RotinasView({data,save,toast2,userId,userName}) {
  const today=new Date().toISOString().slice(0,10);
  const [selDate,setSelDate]=useState(today);
  const [selPlatform,setSelPlatform]=useState("meta");

  const setField=(clientId,platformId,fieldId,value)=>{
    const checks=JSON.parse(JSON.stringify(data.checks||{}));
    if(!checks[selDate])checks[selDate]={};
    if(!checks[selDate][clientId])checks[selDate][clientId]={};
    if(!checks[selDate][clientId][platformId])checks[selDate][clientId][platformId]={};
    const prev=checks[selDate][clientId][platformId][fieldId]||null;
    const next=prev===value?null:value;
    checks[selDate][clientId][platformId][fieldId]=next;
    const entry={
      ts:Date.now(),employeeId:userId||"system",employeeName:userName||"Sistema",
      date:selDate,clientId,platform:platformId,field:fieldId,from:prev,to:next,
    };
    save({...data,checks,history:[...(data.history||[]),entry]});
    toast2("Salvo!");
  };

  const setInactive=(clientId,platformId,value)=>{
    const checks=JSON.parse(JSON.stringify(data.checks||{}));
    if(!checks[selDate])checks[selDate]={};
    if(!checks[selDate][clientId])checks[selDate][clientId]={};
    // ao marcar inativo limpa seleções; ao reativar começa do zero
    checks[selDate][clientId][platformId]=value?{inactive:true}:{};
    const entry={
      ts:Date.now(),employeeId:userId||"system",employeeName:userName||"Sistema",
      date:selDate,clientId,platform:platformId,field:"inactive",from:!value,to:value,
    };
    save({...data,checks,history:[...(data.history||[]),entry]});
    toast2(value?"Anúncio marcado como inativo.":"Anúncio reativado.");
  };

  const setObs=(clientId,v)=>{
    const checks=JSON.parse(JSON.stringify(data.checks||{}));
    if(!checks[selDate])checks[selDate]={};
    if(!checks[selDate][clientId])checks[selDate][clientId]={};
    checks[selDate][clientId].obs=v;
    save({...data,checks});
  };

  const days=Array.from({length:7},(_,i)=>{const d=new Date();d.setDate(d.getDate()-(6-i));return d.toISOString().slice(0,10);});
  const WDAYS=["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
  const rotClients=data.clients.filter(c=>c.inRotinas!==false);
  // progresso por plataforma (separados)
  const plProgress=plId=>platformDayProgress(data.checks,rotClients,today,plId);
  const selP=dayProgress(data.checks,rotClients,selDate);
  const empFn=id=>data.employees.find(e=>e.id===id);
  const cliFn=id=>data.clients.find(c=>c.id===id);
  const dayHistory=[...(data.history||[])].filter(h=>h.date===selDate).sort((a,b)=>b.ts-a.ts);
  const fmtTime=ts=>new Date(ts).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});
  const optLabel=(plId,fId,oId)=>{
    if(!oId)return"—";
    const pl=PLATFORMS.find(p=>p.id===plId);
    const f=pl?.fields.find(f=>f.id===fId);
    return f?.opts.find(o=>o.id===oId)?.label||oId;
  };

  return (
    <div className="space-y-5">
      {/* Progresso separado por plataforma */}
      <div className="grid grid-cols-2 gap-4">
        {PLATFORMS.map(pl=>{
          const p=plProgress(pl.id);
          const plClients=rotClients.filter(c=>getClientPlatforms(c).some(x=>x.id===pl.id));
          return (
            <div key={pl.id} className={`bg-white rounded-xl p-5 border shadow-sm transition-colors ${p.pct===1?"border-emerald-200":""}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <span className="text-lg">{pl.icon}</span>
                  <p className="text-sm font-semibold text-gray-700">{pl.label}</p>
                </div>
                <span className="text-xs text-gray-400">{plClients.length} cliente{plClients.length!==1?"s":""}</span>
              </div>
              <div className="flex items-end gap-3">
                <p className="text-3xl font-bold text-gray-800">{p.done}<span className="text-base text-gray-300">/{p.total}</span></p>
                <div className="flex-1 mb-2">
                  <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full transition-all duration-500 ${p.pct===1?"bg-emerald-500":pl.id==="meta"?"bg-blue-500":"bg-green-500"}`} style={{width:`${p.pct*100}%`}}/>
                  </div>
                  <p className="text-xs text-gray-400 mt-1">{Math.round(p.pct*100)}% concluído</p>
                </div>
                {p.pct===1&&<span className="text-2xl">🎉</span>}
              </div>
            </div>
          );
        })}
      </div>

      {/* Seletor de datas — últimos 7 dias */}
      <div className="bg-white rounded-xl border shadow-sm p-4">
        <p className="text-xs text-gray-500 font-semibold mb-3 uppercase tracking-wide">Selecione a data</p>
        <div className="grid grid-cols-7 gap-2">
          {days.map(d=>{
            const meta=platformDayProgress(data.checks,rotClients,d,"meta");
            const gads=platformDayProgress(data.checks,rotClients,d,"gads");
            const isToday=d===today; const isSel=d===selDate;
            return (
              <button key={d} onClick={()=>setSelDate(d)}
                className={`flex flex-col items-center p-2 rounded-xl transition-all ${isSel?"ring-2 ring-indigo-500 bg-indigo-50":isToday?"bg-slate-50":"hover:bg-slate-50"}`}>
                <p className="text-xs text-gray-400 mb-0.5">{WDAYS[new Date(d+"T12:00:00").getDay()]}</p>
                <p className={`text-sm font-bold mb-2 ${isToday?"text-indigo-600":isSel?"text-indigo-500":"text-gray-700"}`}>{d.slice(8)}</p>
                <div className="w-full space-y-1">
                  <div className="flex items-center gap-1">
                    <span className="text-[9px] text-gray-300">🔵</span>
                    <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${meta.pct===1?"bg-emerald-500":"bg-blue-400"}`} style={{width:`${meta.pct*100}%`}}/>
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="text-[9px] text-gray-300">🟢</span>
                    <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${gads.pct===1?"bg-emerald-500":"bg-green-400"}`} style={{width:`${gads.pct*100}%`}}/>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Cabeçalho do dia + abas de plataforma */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <h2 className="font-bold text-gray-700">{selDate===today?"📅 Hoje — "+fmtDate(today):"📅 "+fmtDate(selDate)}</h2>
          <span className={`text-xs px-3 py-1 rounded-full font-semibold ${selP.pct===1?"bg-emerald-100 text-emerald-700":"bg-slate-100 text-slate-500"}`}>
            {selP.done}/{selP.total} campos
          </span>
        </div>
        <div className="flex gap-2">
          {PLATFORMS.map(pl=>(
            <button key={pl.id} onClick={()=>setSelPlatform(pl.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${selPlatform===pl.id?"bg-indigo-600 text-white border-indigo-600":"bg-white text-gray-600 border-slate-200 hover:border-indigo-300"}`}>
              <span>{pl.icon}</span>{pl.label}
            </button>
          ))}
        </div>
      </div>

      {/* Cards por cliente */}
      {rotClients.length===0&&<div className="bg-white rounded-xl border p-10 text-center text-gray-400 text-sm">Nenhum cliente com rotina ativa. Ative em Configurações → Clientes.</div>}
      {rotClients.filter(c=>getClientPlatforms(c).some(p=>p.id===selPlatform)).length===0&&rotClients.length>0&&(
        <div className="bg-white rounded-xl border p-8 text-center text-gray-400 text-sm">Nenhum cliente usa {PLATFORMS.find(p=>p.id===selPlatform)?.label}.</div>
      )}
      {rotClients.filter(c=>getClientPlatforms(c).some(p=>p.id===selPlatform)).map(c=>{
        const pl=PLATFORMS.find(p=>p.id===selPlatform);
        const plData=data.checks?.[selDate]?.[c.id]?.[selPlatform]||{};
        const inactive=!!plData.inactive;
        const aguardandoPag=plData.saldo==="aguardando_pag";
        const total=pl.fields.length;
        const done=(inactive||aguardandoPag)?total:pl.fields.filter(f=>plData[f.id]).length;
        const allDone=done===total&&total>0;
        const obsVal=data.checks?.[selDate]?.[c.id]?.obs||"";
        return (
          <div key={c.id} className={`bg-white rounded-xl border shadow-sm overflow-hidden transition-colors ${inactive?"border-slate-200":allDone?"border-emerald-300":""}`}>
            {/* Cabeçalho */}
            <div className={`px-5 py-3.5 flex items-center justify-between border-b ${inactive?"bg-slate-50":allDone?"bg-emerald-50":""}`}>
              <div className="flex items-center gap-3">
                <span className="text-xl">{inactive?"⏸️":aguardandoPag?"💜":allDone?"✅":"📋"}</span>
                <div>
                  <p className={`font-semibold ${inactive?"text-gray-400":"text-gray-800"}`}>{c.name}</p>
                  <p className="text-xs text-gray-400">
                    {inactive?"Anúncio inativo":aguardandoPag?"Aguardando pagamento":`${done}/${total} preenchidos`} · {pl.icon} {pl.label}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 w-36">
                <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
                  <div className={`h-full rounded-full transition-all ${inactive?"bg-slate-300":allDone?"bg-emerald-500":"bg-indigo-500"}`} style={{width:`${total?(done/total)*100:0}%`}}/>
                </div>
                <span className="text-xs text-gray-400 w-8 text-right">{total?Math.round(done/total*100):0}%</span>
              </div>
            </div>
            {/* Body */}
            <div className="px-5 py-4 space-y-4">
              {/* Toggle Anúncio Inativo */}
              <label className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border cursor-pointer select-none transition-colors ${inactive?"bg-slate-100 border-slate-300":"bg-slate-50 border-slate-200 hover:border-orange-200 hover:bg-orange-50"}`}>
                <input type="checkbox" checked={inactive}
                  onChange={e=>setInactive(c.id,selPlatform,e.target.checked)}
                  className="w-4 h-4 rounded accent-orange-500"/>
                <div>
                  <p className="text-xs font-semibold text-gray-700">⛔ Anúncio inativo</p>
                  <p className="text-xs text-gray-400">Marque se não há campanha ativa hoje</p>
                </div>
              </label>
              {/* Campos (ocultados quando inativo) */}
              {inactive
                ?<p className="text-xs text-gray-400 italic text-center py-1">Sem campos para preencher — nenhuma campanha ativa.</p>
                :pl.fields.map(f=>(
                  <div key={f.id}>
                    <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-2">{f.label}</p>
                    <div className="flex flex-wrap gap-2">
                      {f.opts.map(o=>{
                        const sel=plData[f.id]===o.id;
                        return (
                          <button key={o.id} onClick={()=>setField(c.id,selPlatform,f.id,o.id)}
                            className={`px-3 py-1.5 rounded-full border text-xs font-semibold transition-all ${sel?FIELD_COLORS[o.id]||"bg-indigo-100 text-indigo-700 border-indigo-300":"bg-slate-50 text-gray-400 border-slate-200 hover:border-indigo-300 hover:text-indigo-600"}`}>
                            {sel&&"✓ "}{o.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))
              }
              {/* Observação do dia */}
              <div>
                <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1.5">📝 Observações</p>
                <ObsField value={obsVal} onSave={v=>setObs(c.id,v)}/>
              </div>
            </div>
          </div>
        );
      })}

      {/* Histórico imutável */}
      <div className="bg-white rounded-xl border shadow-sm overflow-hidden">
        <div className="px-5 py-3.5 border-b flex items-center justify-between bg-slate-50">
          <div>
            <p className="font-semibold text-gray-700 text-sm">🕓 Histórico de edições</p>
            <p className="text-xs text-gray-400 mt-0.5">Registros imutáveis — {selDate===today?"hoje":"dia "+fmtDate(selDate)}</p>
          </div>
          <span className="text-xs bg-slate-200 text-slate-600 px-2 py-0.5 rounded-full">{dayHistory.length} registro{dayHistory.length!==1?"s":""}</span>
        </div>
        {dayHistory.length===0
          ?<div className="px-5 py-8 text-center text-gray-300 text-sm">Nenhuma edição registrada neste dia.</div>
          :<div className="divide-y max-h-72 overflow-y-auto">
            {dayHistory.map((h,i)=>{
              const pl=PLATFORMS.find(p=>p.id===h.platform);
              const f=pl?.fields.find(f=>f.id===h.field);
              const isInactiveEntry=h.field==="inactive";
              return (
                <div key={i} className="px-5 py-3 flex items-start gap-3">
                  <p className="text-xs font-mono text-gray-400 w-12 flex-shrink-0">{fmtTime(h.ts)}</p>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-xs font-semibold text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded-full">{h.employeeName||empFn(h.employeeId)?.name||"—"}</span>
                      <span className="text-xs text-gray-500">{cliFn(h.clientId)?.name||"—"}</span>
                      <span className="text-xs text-gray-300">·</span>
                      <span className="text-xs text-gray-500">
                        {pl?.icon} {pl?.label}{!isInactiveEntry&&f?` — ${f.label}`:""}
                      </span>
                    </div>
                    {isInactiveEntry
                      ?<span className={`inline-block mt-1 text-xs px-2 py-0.5 rounded-full border font-medium ${h.to?"bg-slate-100 text-slate-600 border-slate-300":"bg-emerald-50 text-emerald-700 border-emerald-200"}`}>
                        {h.to?"⛔ Marcado como inativo":"✅ Reativado"}
                      </span>
                      :<div className="flex items-center gap-2 mt-1">
                        <span className={`text-xs px-2 py-0.5 rounded-full border ${h.from?FIELD_COLORS[h.from]||"bg-slate-100 text-slate-500 border-slate-200":"bg-slate-50 text-slate-300 border-slate-100"}`}>
                          {optLabel(h.platform,h.field,h.from)}
                        </span>
                        <span className="text-gray-300 text-xs">→</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full border ${h.to?FIELD_COLORS[h.to]||"bg-indigo-100 text-indigo-700 border-indigo-200":"bg-slate-50 text-slate-300 border-slate-100"}`}>
                          {optLabel(h.platform,h.field,h.to)}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              );
            })}
          </div>}
      </div>
    </div>
  );
}

// ── CONFIG ─────────────────────────────────────────────────
function ConfigPanel({data,save,toast2}) {
  const [cli,setCli]=useState({name:"",inRotinas:true,platforms:["meta","gads"]});
  const [editingCli,setEditingCli]=useState(null); // null | client object sendo editado
  const [proj,setProj]=useState({name:"",clientId:""}); const [fmt,setFmt]=useState("");
  const card="bg-white rounded-xl border shadow-sm p-5"; const inp="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 mb-2"; const btn="w-full bg-indigo-600 text-white text-sm py-2 rounded-lg hover:bg-indigo-700 font-medium";
  return (
    <div className="grid grid-cols-2 gap-5">
      <div className={card}>
        <h3 className="font-semibold text-gray-800 mb-4">🗂 Formatos</h3>
        <div className="flex flex-wrap gap-2 mb-4 max-h-44 overflow-y-auto">
          {data.formats.map(f=><div key={f} className="flex items-center gap-1 bg-slate-100 text-slate-700 text-xs px-2.5 py-1 rounded-full">{f}<button onClick={()=>{save({...data,formats:data.formats.filter(x=>x!==f)});toast2("Removido.","info");}} className="text-red-400 hover:text-red-600 ml-1 font-bold">×</button></div>)}
        </div>
        <input className={inp} placeholder="Novo formato" value={fmt} onChange={e=>setFmt(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter"&&fmt.trim()&&!data.formats.includes(fmt.trim())){save({...data,formats:[...data.formats,fmt.trim()]});setFmt("");toast2("Adicionado!");}}}/>
        <button className={btn} onClick={()=>{if(fmt.trim()&&!data.formats.includes(fmt.trim())){save({...data,formats:[...data.formats,fmt.trim()]});setFmt("");toast2("Adicionado!");}}}>+ Adicionar Formato</button>
      </div>
      <div className={card}>
        <h3 className="font-semibold text-gray-800 mb-2">👥 Funcionários</h3>
        <p className="text-xs text-gray-400 mb-4">Gerenciado automaticamente pela seção <strong>Usuários</strong>.</p>
        <div className="space-y-2 max-h-44 overflow-y-auto">
          {data.employees.length===0&&<p className="text-xs text-gray-400 italic">Nenhum usuário cadastrado ainda.</p>}
          {data.employees.map(e=>(
            <div key={e.id} className="flex items-center gap-2 py-1.5 border-b last:border-0">
              <Avatar name={e.name}/>
              <div><p className="text-xs font-medium text-gray-700">{e.name}</p>{e.role&&<p className="text-xs text-indigo-500">{e.role}</p>}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={card}>
        <h3 className="font-semibold text-gray-800 mb-4">🏢 Clientes</h3>
        <div className="space-y-2 mb-4 max-h-52 overflow-y-auto">
          {data.clients.map(c=>{
            const pls=getClientPlatforms(c);
            const isEditing=editingCli?.id===c.id;
            return (
              <div key={c.id} className={`py-1.5 border-b ${isEditing?"bg-indigo-50 rounded-lg px-2":""}`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="text-xs font-medium text-gray-700">{c.name}</p>
                    {c.inRotinas!==false
                      ?<>{pls.map(pl=><span key={pl.id} className="text-xs bg-indigo-100 text-indigo-600 px-1.5 py-0.5 rounded-full">{pl.icon} {pl.label}</span>)}</>
                      :<span className="text-xs bg-slate-100 text-slate-400 px-1.5 py-0.5 rounded-full">Sem rotina</span>}
                  </div>
                  <div className="flex items-center gap-1 ml-2 flex-shrink-0">
                    <button title="Editar cliente" onClick={()=>setEditingCli(isEditing?null:{...c})} className={`text-xs px-2 py-0.5 rounded font-medium transition ${isEditing?"bg-indigo-200 text-indigo-700":"text-indigo-400 hover:text-indigo-600 hover:bg-indigo-50"}`}>✏️</button>
                    <button title="Remover cliente" onClick={()=>{if(window.confirm(`Remover "${c.name}"? O histórico de demandas e rotinas será preservado.`)){save({...data,clients:data.clients.filter(x=>x.id!==c.id)});toast2("Removido.","info");}}} className="text-red-400 hover:text-red-600 text-xs px-1">✕</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Formulário de edição */}
        {editingCli&&(
          <div className="mb-4 bg-indigo-50 border border-indigo-200 rounded-xl p-4 space-y-2">
            <p className="text-xs font-semibold text-indigo-700 mb-2">✏️ Editando: {editingCli.name}</p>
            <input className={inp} placeholder="Nome do Cliente" value={editingCli.name} onChange={e=>setEditingCli({...editingCli,name:e.target.value})}/>
            <label className="flex items-center gap-2 text-xs text-gray-600 mb-2 cursor-pointer select-none">
              <input type="checkbox" checked={editingCli.inRotinas!==false}
                onChange={e=>setEditingCli({...editingCli,inRotinas:e.target.checked,platforms:e.target.checked?(editingCli.platforms?.length?editingCli.platforms:["meta","gads"]):[]})}
                className="rounded"/>
              Entra na lista de Rotinas diárias
            </label>
            {editingCli.inRotinas!==false&&(
              <div className="bg-white rounded-lg px-3 py-2.5 space-y-1.5 border border-indigo-100">
                <p className="text-xs text-gray-500 font-semibold mb-1">Plataformas:</p>
                {PLATFORMS.map(pl=>(
                  <label key={pl.id} className="flex items-center gap-2 text-xs text-gray-700 cursor-pointer select-none">
                    <input type="checkbox"
                      checked={(editingCli.platforms||[]).includes(pl.id)}
                      onChange={e=>setEditingCli({...editingCli,platforms:e.target.checked?[...(editingCli.platforms||[]),pl.id]:(editingCli.platforms||[]).filter(p=>p!==pl.id)})}
                      className="rounded"/>
                    {pl.icon} {pl.label}
                  </label>
                ))}
                {(editingCli.platforms||[]).length===0&&<p className="text-xs text-red-400">Selecione ao menos uma plataforma.</p>}
              </div>
            )}
            <div className="flex gap-2 pt-1">
              <button className="flex-1 border border-gray-200 text-gray-600 text-xs py-2 rounded-lg hover:bg-gray-50" onClick={()=>setEditingCli(null)}>Cancelar</button>
              <button className="flex-1 bg-indigo-600 text-white text-xs py-2 rounded-lg hover:bg-indigo-700 font-medium" onClick={()=>{
                if(!editingCli.name.trim())return;
                if(editingCli.inRotinas!==false&&(editingCli.platforms||[]).length===0)return toast2("Selecione ao menos uma plataforma.","info");
                save({...data,clients:data.clients.map(c=>c.id===editingCli.id?{...editingCli,name:editingCli.name.trim()}:c)});
                setEditingCli(null);toast2("Cliente atualizado!");
              }}>Salvar alterações</button>
            </div>
          </div>
        )}

        {/* Formulário de criação */}
        {!editingCli&&(
          <>
            <input className={inp} placeholder="Nome do Cliente" value={cli.name} onChange={e=>setCli({...cli,name:e.target.value})}/>
            <label className="flex items-center gap-2 text-xs text-gray-600 mb-2 cursor-pointer select-none">
              <input type="checkbox" checked={cli.inRotinas} onChange={e=>setCli({...cli,inRotinas:e.target.checked,platforms:e.target.checked?["meta","gads"]:[]})} className="rounded"/>
              Entra na lista de Rotinas diárias
            </label>
            {cli.inRotinas&&(
              <div className="mb-2 bg-slate-50 rounded-lg px-3 py-2.5 space-y-1.5">
                <p className="text-xs text-gray-500 font-semibold mb-1">Plataformas do cliente:</p>
                {PLATFORMS.map(pl=>(
                  <label key={pl.id} className="flex items-center gap-2 text-xs text-gray-700 cursor-pointer select-none">
                    <input type="checkbox"
                      checked={cli.platforms.includes(pl.id)}
                      onChange={e=>setCli({...cli,platforms:e.target.checked?[...cli.platforms,pl.id]:cli.platforms.filter(p=>p!==pl.id)})}
                      className="rounded"/>
                    {pl.icon} {pl.label}
                  </label>
                ))}
                {cli.platforms.length===0&&<p className="text-xs text-red-400">Selecione ao menos uma plataforma.</p>}
              </div>
            )}
            <button className={btn} onClick={()=>{
              if(!cli.name.trim())return;
              if(cli.inRotinas&&cli.platforms.length===0)return toast2("Selecione ao menos uma plataforma.","info");
              save({...data,clients:[...data.clients,{name:cli.name.trim(),id:`c${Date.now()}`,inRotinas:cli.inRotinas,platforms:cli.platforms}]});
              setCli({name:"",inRotinas:true,platforms:["meta","gads"]});
              toast2("Adicionado!");
            }}>+ Adicionar Cliente</button>
          </>
        )}
      </div>
      <div className={card}>
        <h3 className="font-semibold text-gray-800 mb-4">📁 Projetos</h3>
        <div className="space-y-2 mb-4 max-h-44 overflow-y-auto">
          {data.projects.map(p=>(
            <div key={p.id} className="flex items-center justify-between py-1.5 border-b">
              <div><p className="text-xs font-medium text-gray-700">{p.name}</p><p className="text-xs text-gray-400">{data.clients.find(c=>c.id===p.clientId)?.name}</p></div>
              <button onClick={()=>{save({...data,projects:data.projects.filter(x=>x.id!==p.id)});toast2("Removido.","info");}} className="text-red-400 hover:text-red-600 text-xs">✕</button>
            </div>
          ))}
        </div>
        <input className={inp} placeholder="Nome do Projeto" value={proj.name} onChange={e=>setProj({...proj,name:e.target.value})}/>
        <select className={inp} value={proj.clientId} onChange={e=>setProj({...proj,clientId:e.target.value})}>
          <option value="">Vincular ao cliente...</option>
          {data.clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <button className={btn} onClick={()=>{if(!proj.name.trim())return;save({...data,projects:[...data.projects,{...proj,id:`p${Date.now()}`}]});setProj({name:"",clientId:""});toast2("Adicionado!");}}>+ Adicionar Projeto</button>
      </div>
    </div>
  );
}

function RevModal({demand,onClose,onSubmit}) {
  const [c,setC]=useState("");
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        <div className="px-6 py-4 border-b flex justify-between items-center">
          <h2 className="font-bold text-gray-800">Solicitar Revisão</h2>
          <button onClick={onClose} className="text-gray-400 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100">✕</button>
        </div>
        <div className="p-6">
          <p className="text-sm text-gray-600 mb-3">Ajustes em <strong>{demand?.title}</strong>:</p>
          <textarea className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none" rows={4} value={c} onChange={e=>setC(e.target.value)} placeholder="Descreva os ajustes..."/>
        </div>
        <div className="px-6 py-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-50">Cancelar</button>
          <button onClick={()=>onSubmit(c)} className="px-5 py-2 text-sm bg-orange-500 text-white rounded-lg hover:bg-orange-600 font-medium">Enviar</button>
        </div>
      </div>
    </div>
  );
}

// ── MAIN APP ───────────────────────────────────────────────
function AgencyMain({isAdmin,userId,userName,onLogout}) {
  const [data,setData]=useState(SEED);
  const [view,setView]=useState("dashboard");
  const [sidebar,setSidebar]=useState(true);
  const [modal,setModal]=useState(false);
  const [editId,setEditId]=useState(null);
  const [form,setForm]=useState({});
  const [formFiles,setFormFiles]=useState([]);
  const [approvalModal,setApprovalModal]=useState(null);
  const [filters,setFilters]=useState({employee:"all",client:"all",project:"all",status:"all",format:"all"});
  const [toast,setToast]=useState(null);
  const [copiedLink,setCopiedLink]=useState({});

  useEffect(()=>{
    (async()=>{
      try{
        // carrega dados: prioridade agpro_data → agpro_v7 → agpro_v6
        let raw=await window.storage.get("agpro_data");
        if(!raw) raw=await window.storage.get("agpro_v7");
        if(!raw) raw=await window.storage.get("agpro_v6");
        const saved=raw?JSON.parse(raw.value):null;
        // merge-with-defaults: nunca sobrescreve campos existentes, só preenche os ausentes
        let d={
          employees: saved?.employees ?? SEED.employees,
          clients:   saved?.clients   ?? SEED.clients,
          projects:  saved?.projects  ?? SEED.projects,
          formats:   saved?.formats   ?? SEED.formats,
          checks:    saved?.checks    ?? SEED.checks,
          history:   saved?.history   ?? SEED.history,
          demands:   saved?.demands   ?? SEED.demands,
        };
        // normaliza arquivos
        d={...d,demands:d.demands.map(x=>({
          ...x,
          files:x.files||(x.driveLink?[{id:"f0",name:"Arquivo",url:x.driveLink}]:[]),
          fileApprovals:x.fileApprovals||{},
          status:STATUS_MIGRATION[x.status]||x.status,
        }))};
        // remove arquivadas antigas
        d={...d,demands:d.demands.filter(x=>!x.archivedAt||(Date.now()-new Date(x.archivedAt).getTime()<SIX_MONTHS))};
        // sincroniza aprovações externas
        const synced=[...d.demands];
        for(let i=0;i<synced.length;i++){
          if(["falta_aprovar","revisao"].includes(synced[i].status)){
            try{
              const res=await window.storage.get(`ap_result:${synced[i].id}`,true);
              if(res){
                const rv=JSON.parse(res.value);
                const merged={...(synced[i].fileApprovals||{}),...rv};
                const ov=overallApproval(merged,synced[i].files||[]);
                let newStatus=synced[i].status;
                let newDescription=synced[i].description||"";
                if(ov==="aprovado"){
                  newStatus="aprovado";
                } else if(ov==="revisao"){
                  newStatus="revisao";
                  // coleta feedbacks do cliente e adiciona na descrição (uma vez)
                  const comments=Object.entries(merged)
                    .filter(([,v])=>v.status==="revisao"&&v.comment)
                    .map(([fid,v])=>{
                      const file=(synced[i].files||[]).find(f=>f.id===fid);
                      return `• ${file?.name||fid}: ${v.comment}`;
                    });
                  if(comments.length>0&&!newDescription.includes("📝 Feedback do cliente:")){
                    newDescription=(newDescription?newDescription+"\n\n":"")+
                      "📝 Feedback do cliente:\n"+comments.join("\n");
                  }
                }
                synced[i]={...synced[i],fileApprovals:merged,status:newStatus,description:newDescription};
              }
            }catch{}
          }
        }
        setData({...d,demands:synced});
      }catch{}
    })();
  },[]);

  const save=async d=>{setData(d);try{await window.storage.set("agpro_data",JSON.stringify(d));}catch{}};
  const toast2=(msg,type="success")=>{setToast({msg,type});setTimeout(()=>setToast(null),2500);};

  const EMPTY={title:"",description:"",descImages:[],format:data.formats?.[0]||"",deadline:"",priority:"media",status:"falta_arte",assignedTo:"",clientId:"",projectId:"",files:[],fileApprovals:{},archivedAt:null};

  const openCreate=()=>{setForm(EMPTY);setFormFiles([]);setEditId(null);setModal(true);};
  const openEdit=d=>{setForm({...d,descImages:d.descImages||[]});setFormFiles([...(d.files||[])]);setEditId(d.id);setModal(true);};

  const descFileRef=useRef();

  // processa um File de imagem → base64 redimensionado, retorna Promise<{id,name,url}>
  const processImageFile=file=>new Promise(resolve=>{
    const reader=new FileReader();
    reader.onload=ev=>{
      const img=new Image();
      img.onload=()=>{
        const MAX=900;
        let w=img.width,h=img.height;
        if(w>MAX){h=Math.round(h*MAX/w);w=MAX;}
        const canvas=document.createElement("canvas");
        canvas.width=w;canvas.height=h;
        canvas.getContext("2d").drawImage(img,0,0,w,h);
        const url=canvas.toDataURL("image/jpeg",0.75);
        resolve({id:`img${Date.now()}`,name:file.name||"imagem.jpg",url});
      };
      img.src=ev.target.result;
    };
    reader.readAsDataURL(file);
  });

  // cola imagem no campo descrição (Ctrl+V)
  const handleDescPaste=async e=>{
    const items=Array.from(e.clipboardData?.items||[]);
    const imgItem=items.find(it=>it.type.startsWith("image/"));
    if(!imgItem) return;
    e.preventDefault();
    const entry=await processImageFile(imgItem.getAsFile());
    setForm(f=>({...f,descImages:[...(f.descImages||[]),entry]}));
    toast2("🖼️ Imagem colada!");
  };

  // seleciona arquivo pelo botão
  const handleDescFileUpload=async e=>{
    const files=Array.from(e.target.files||[]);
    if(!files.length) return;
    const entries=await Promise.all(files.filter(f=>f.type.startsWith("image/")).map(processImageFile));
    if(!entries.length){toast2("Selecione arquivos de imagem (PNG, JPG, etc).","warn");return;}
    setForm(f=>({...f,descImages:[...(f.descImages||[]),...entries]}));
    toast2(`🖼️ ${entries.length} imagem${entries.length!==1?"ns":""} adicionada${entries.length!==1?"s":""}!`);
    e.target.value=""; // reseta input para permitir mesmo arquivo novamente
  };

  // download de imagem base64
  const downloadDescImage=(img)=>{
    const a=document.createElement("a");
    a.href=img.url;
    a.download=img.name||`imagem-${img.id}.jpg`;
    a.click();
  };
  const addFormFile=()=>setFormFiles(f=>[...f,{id:`f${Date.now()}`,name:"",url:""}]);
  const updateFormFile=(id,key,val)=>setFormFiles(f=>f.map(x=>x.id===id?{...x,[key]:val}:x));
  const removeFormFile=id=>setFormFiles(f=>f.filter(x=>x.id!==id));

  const saveDemand=()=>{
    if(!form.title.trim())return;
    const files=formFiles.filter(f=>f.url.trim());
    // exige pelo menos um arquivo para enviar para aprovação
    if(form.status==="falta_aprovar"&&files.length===0){
      toast2("⚠️ Adicione pelo menos um arquivo para enviar para aprovação.","warn");
      return;
    }
    const d={...form,files,fileApprovals:form.fileApprovals||{}};
    const demands=editId
      ?data.demands.map(x=>x.id===editId?{...x,...d}:x)
      :[...data.demands,{...d,id:`d${Date.now()}`,createdAt:new Date().toISOString().slice(0,10)}];
    save({...data,demands});
    setModal(false);
    toast2(editId?"Atualizada!":"Criada!");
    // ao marcar como "falta aprovar", vai direto para a aba Aprovações
    if(form.status==="falta_aprovar") setView("aprovacoes");
  };

  const delDemand=id=>{save({...data,demands:data.demands.filter(d=>d.id!==id)});toast2("Removida.","info");};
  const archiveDemand=id=>{save({...data,demands:data.demands.map(d=>d.id===id?{...d,status:"arquivada",archivedAt:new Date().toISOString()}:d)});toast2("Arquivada!");};
  const restoreDemand=id=>{save({...data,demands:data.demands.map(d=>d.id===id?{...d,status:"aprovado",archivedAt:null}:d)});toast2("Restaurada!");};
  const updatePriority=(id,priority)=>{save({...data,demands:data.demands.map(d=>d.id===id?{...d,priority}:d)});toast2("Urgência atualizada!");};

  const doApproval=(id,status,comment="",fileId=null)=>{
    const demands=data.demands.map(d=>{
      if(d.id!==id)return d;
      if(fileId){
        const fa={...(d.fileApprovals||{}),[fileId]:{status,comment,ts:Date.now()}};
        const ov=overallApproval(fa,d.files||[]);
        return {...d,fileApprovals:fa,status:ov==="aprovado"?"aprovado":d.status};
      }
      return {...d,status:status==="aprovado"?"aprovado":d.status};
    });
    save({...data,demands});toast2(status==="aprovado"?"✅ Aprovado!":"🔄 Revisão!");
  };

  const shareApproval=async d=>{
    const link=genLink(d);
    navigator.clipboard?.writeText(link);
    setCopiedLink(p=>({...p,[d.id]:true}));
    setTimeout(()=>setCopiedLink(p=>({...p,[d.id]:false})),2500);
    toast2("Link copiado!");
  };

  const emp=id=>data.employees.find(e=>e.id===id);
  const cli=id=>data.clients.find(c=>c.id===id);
  const proj=id=>data.projects.find(p=>p.id===id);
  const active=data.demands.filter(d=>d.status!=="arquivada");

  // sincroniza lista de usuários → employees (chamado pelo UsersPage)
  const syncEmployees=users=>{
    const employees=users
      .filter(u=>u.is_active!==false)
      .map(u=>({id:String(u.id),name:u.name,role:u.funcao||""}));
    save({...data,employees});
  };
  const archived=data.demands.filter(d=>d.status==="arquivada");
  const pendingApproval=active.filter(d=>d.status==="falta_aprovar").length;
  const filtered=active.filter(d=>{
    if(filters.employee!=="all"&&d.assignedTo!==filters.employee)return false;
    if(filters.client!=="all"&&d.clientId!==filters.client)return false;
    if(filters.project!=="all"&&d.projectId!==filters.project)return false;
    if(filters.status!=="all"&&d.status!==filters.status)return false;
    if(filters.format!=="all"&&d.format!==filters.format)return false;
    return true;
  });

  const nav=[
    {id:"dashboard",icon:"📊",label:"Dashboard"},
    {id:"demandas",icon:"📋",label:"Demandas"},
    {id:"funcionarios",icon:"👥",label:"Funcionários"},
    {id:"aprovacoes",icon:"✅",label:"Aprovações",badge:pendingApproval},
    {id:"rotinas",icon:"📅",label:"Rotinas"},
    {id:"arquivo",icon:"🗂",label:"Arquivo",badge:archived.length||null},
    {id:"config",icon:"⚙️",label:"Configurações"},
    ...(isAdmin?[
      {id:"__sep__",sep:true},
      {id:"usuarios",icon:"👤",label:"Usuários"},
      {id:"permissoes",icon:"🔑",label:"Permissões"},
    ]:[]),
  ];
  const legend=[{lv:C.urgente,l:"≤2 dias — Urgente"},{lv:C.alta,l:"≤4 dias — Alto"},{lv:C.media,l:"≤5 dias — Médio"},{lv:C.baixa,l:">5 dias — Normal"}];
  const tableH=["Título","Formato","Responsável","Cliente / Proj.","Prazo","Urgência","Status",""];

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden" style={{fontFamily:"system-ui,sans-serif"}}>
      {/* SIDEBAR */}
      <aside className={`${sidebar?"w-52":"w-14"} bg-gray-900 flex flex-col flex-shrink-0 transition-all duration-200`}>
        <div className="flex items-center px-3 py-3 border-b border-gray-700">
          {sidebar
            ?<img src="/logo.png" alt="Agência Vulpez" className="h-8 w-auto object-contain flex-1 min-w-0"/>
            :<span className="text-white text-lg mx-auto">V</span>}
          <button onClick={()=>setSidebar(!sidebar)} className="text-gray-400 hover:text-white w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-700 ml-auto flex-shrink-0">{sidebar?"◀":"▶"}</button>
        </div>
        <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
          {nav.map(item=>item.sep
            ?<div key={item.id} className={`border-t border-gray-700 my-2 ${sidebar?"":"mx-1"}`}/>
            :<button key={item.id} onClick={()=>setView(item.id)}
              className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-colors ${view===item.id?"bg-indigo-600 text-white":"text-gray-300 hover:bg-gray-700 hover:text-white"}`}>
              <span className="text-base flex-shrink-0">{item.icon}</span>
              {sidebar&&<span className="truncate flex-1 text-left">{item.label}</span>}
              {item.badge>0&&<span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center flex-shrink-0">{item.badge}</span>}
            </button>
          )}
        </nav>
        <div className="p-3 border-t border-gray-700 space-y-2">
          {sidebar&&<div className="space-y-1 mb-2">
            <p className="text-gray-500 text-xs font-semibold uppercase tracking-wide">Legenda Prazo</p>
            {legend.map((l,i)=><div key={i} className={`px-2 py-1 rounded text-xs font-medium ${l.lv.bg} ${l.lv.text}`}>{l.l}</div>)}
          </div>}
          <div className={`border-t border-gray-700 pt-2 space-y-1 ${!sidebar?"flex flex-col items-center":""}`}>
            {sidebar&&<p className="text-gray-400 text-xs truncate px-1">{userName}</p>}
            <button onClick={onLogout} className={`w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-xs text-gray-400 hover:text-red-400 hover:bg-gray-700 transition-colors ${!sidebar?"justify-center":""}`}>
              <span>↩</span>{sidebar&&<span>Sair</span>}
            </button>
          </div>
        </div>
      </aside>

      {/* CONTEÚDO */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b px-6 py-3.5 flex items-center justify-between flex-shrink-0">
          <div>
            <h1 className="font-bold text-gray-800 text-lg">{nav.find(n=>n.id===view)?.label}</h1>
            {view==="dashboard"&&<p className="text-xs text-gray-400">Clique na linha para ver detalhes · clique na urgência para editar</p>}
            {view==="rotinas"&&<p className="text-xs text-gray-400">Check diário por plataforma · histórico imutável</p>}
          </div>
          <div className="flex items-center gap-3">
            {["dashboard","demandas","funcionarios"].includes(view)&&(
              <button onClick={openCreate} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium">+ Nova Demanda</button>
            )}
            {(view==="usuarios"||view==="permissoes")&&<span className="text-xs text-gray-400">Somente administradores</span>}
          </div>
        </header>

        <main className="flex-1 overflow-auto p-5">
          {/* DASHBOARD */}
          {view==="dashboard"&&(
            <div className="space-y-5">
              <div className="grid grid-cols-4 gap-4">
                {STATUS_GROUPS.map(g=>{
                  const count=active.filter(d=>STATUSES[d.status]?.group===g.id).length;
                  return (
                    <div key={g.id} className="bg-white rounded-xl p-4 border shadow-sm">
                      <p className="text-xs text-gray-500 mb-2">{g.label}</p>
                      <p className="text-4xl font-bold text-gray-800">{count}</p>
                    </div>
                  );
                })}
              </div>
              <div className="bg-white rounded-xl border shadow-sm">
                <div className="px-5 py-3 border-b flex justify-between"><h2 className="font-semibold text-gray-700">Demandas Ativas</h2><span className="text-xs text-gray-400">{active.length} total</span></div>
                <Table demands={active} emp={emp} cli={cli} proj={proj} heads={tableH} onEdit={openEdit} onDelete={delDemand} onArchive={archiveDemand} onApproval={setApprovalModal}
                  renderPriority={d=><InlinePriority value={d.priority} onChange={v=>updatePriority(d.id,v)}/>}/>
              </div>
            </div>
          )}

          {/* DEMANDAS */}
          {view==="demandas"&&(
            <div className="space-y-4">
              <div className="bg-white rounded-xl border p-3 flex gap-2 flex-wrap shadow-sm">
                {[{k:"employee",l:"Funcionário",opts:data.employees.map(e=>({v:e.id,l:e.name}))},
                  {k:"client",l:"Cliente",opts:data.clients.map(c=>({v:c.id,l:c.name}))},
                  {k:"project",l:"Projeto",opts:data.projects.map(p=>({v:p.id,l:p.name}))},
                  {k:"format",l:"Formato",opts:data.formats.map(f=>({v:f,l:f}))},
                ].map(({k,l,opts})=>(
                  <select key={k} className="border rounded-lg px-2 py-1.5 text-xs bg-white" value={filters[k]} onChange={e=>setFilters({...filters,[k]:e.target.value})}>
                    <option value="all">Todos {l}s</option>
                    {opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                ))}
                <select className="border rounded-lg px-2 py-1.5 text-xs bg-white" value={filters.status} onChange={e=>setFilters({...filters,status:e.target.value})}>
                  <option value="all">Todos Status</option>
                  {STATUS_GROUPS.map(g=>(
                    <optgroup key={g.id} label={g.label}>
                      {Object.entries(STATUSES).filter(([,v])=>v.group===g.id).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
                    </optgroup>
                  ))}
                </select>
                {Object.values(filters).some(v=>v!=="all")&&<button onClick={()=>setFilters({employee:"all",client:"all",project:"all",status:"all",format:"all"})} className="text-xs text-indigo-600 px-2">Limpar</button>}
                <span className="ml-auto self-center text-xs text-gray-400">{filtered.length} demandas</span>
              </div>
              <div className="bg-white rounded-xl border shadow-sm">
                <Table demands={filtered} emp={emp} cli={cli} proj={proj} heads={tableH} onEdit={openEdit} onDelete={delDemand} onArchive={archiveDemand} onApproval={setApprovalModal}
                  renderPriority={d=><PBadge value={d.priority}/>}/>
              </div>
            </div>
          )}

          {/* FUNCIONÁRIOS */}
          {view==="funcionarios"&&(
            <div className="space-y-4">
              {data.employees.map(e=>{
                const ed=active.filter(d=>d.assignedTo===e.id);
                return (
                  <div key={e.id} className="bg-white rounded-xl border shadow-sm">
                    <div className="px-5 py-3.5 border-b flex items-center gap-3">
                      <Avatar name={e.name} size="md"/>
                      <div className="flex-1"><p className="font-semibold text-gray-800 text-sm">{e.name}</p><p className="text-xs text-gray-400">{e.role} · {ed.length} demandas</p></div>
                      <div className="flex gap-1.5 flex-wrap">
                        {STATUS_GROUPS.map(g=>{const c=ed.filter(d=>STATUSES[d.status]?.group===g.id).length;return c>0?<span key={g.id} className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">{g.label.split(" ")[1]}: {c}</span>:null;})}
                      </div>
                    </div>
                    <Table demands={ed} emp={emp} cli={cli} proj={proj} heads={tableH} onEdit={openEdit} onDelete={delDemand} onArchive={archiveDemand} onApproval={setApprovalModal}
                      renderPriority={d=><PBadge value={d.priority}/>}/>
                  </div>
                );
              })}
            </div>
          )}

          {/* APROVAÇÕES */}
          {view==="aprovacoes"&&(
            <div className="space-y-4">
              {active.filter(d=>d.status==="falta_aprovar").length===0&&(
                <div className="bg-white rounded-xl border p-14 text-center"><p className="text-4xl mb-2">✅</p><p className="text-gray-400">Nenhuma demanda aguardando aprovação.</p></div>
              )}
              {active.filter(d=>d.status==="falta_aprovar").map(d=>(
                <ApprovalCard key={d.id} d={d} emp={emp} cli={cli}
                  doApproval={doApproval} shareApproval={shareApproval} copiedLink={copiedLink}/>
              ))}
            </div>
          )}

          {/* ROTINAS */}
          {view==="rotinas"&&(
            <RotinasView data={data} save={save} toast2={toast2} userId={userId} userName={userName}/>
          )}

          {/* ARQUIVO */}
          {view==="arquivo"&&(
            <div className="space-y-4">
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-700 flex items-start gap-2">
                <span>🗂</span><div><strong>Arquivo histórico:</strong> Demandas são mantidas por 6 meses e apagadas automaticamente.</div>
              </div>
              {archived.length===0&&<div className="bg-white rounded-xl border p-14 text-center"><p className="text-3xl mb-2">📭</p><p className="text-gray-400">Nenhuma demanda arquivada.</p></div>}
              {archived.length>0&&<div className="bg-white rounded-xl border shadow-sm overflow-x-auto">
                <table className="w-full text-sm">
                  <thead><tr className="bg-slate-50 text-left text-xs text-gray-500 uppercase">
                    {["Título","Responsável","Cliente","Prazo","Arquivada em",""].map((h,i)=><th key={i} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>)}
                  </tr></thead>
                  <tbody className="divide-y">
                    {archived.map(d=>(
                      <tr key={d.id} className="hover:bg-slate-50">
                        <td className="px-4 py-3"><p className="text-xs font-medium text-gray-700">{d.title}</p></td>
                        <td className="px-4 py-3"><div className="flex items-center gap-1.5"><Avatar name={emp(d.assignedTo)?.name}/><span className="text-xs">{emp(d.assignedTo)?.name||"—"}</span></div></td>
                        <td className="px-4 py-3 text-xs text-gray-600">{cli(d.clientId)?.name||"—"}</td>
                        <td className="px-4 py-3"><DLine value={d.deadline}/></td>
                        <td className="px-4 py-3 text-xs text-gray-400">{fmtDate(d.archivedAt?.slice(0,10))||"—"}</td>
                        <td className="px-4 py-3"><div className="flex gap-2">
                          <button onClick={()=>restoreDemand(d.id)} className="text-indigo-500 hover:text-indigo-700 text-xs font-medium">Restaurar</button>
                          <button onClick={()=>delDemand(d.id)} className="text-red-400 hover:text-red-600 text-xs font-medium">Apagar</button>
                        </div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>}
            </div>
          )}

          {view==="config"&&<ConfigPanel data={data} save={save} toast2={toast2}/>}
          {view==="usuarios"&&<UsersPage onUsersChange={syncEmployees}/>}
          {view==="permissoes"&&<PermissionsPage/>}
        </main>
      </div>

      {/* MODAL NOVA/EDITAR DEMANDA */}
      {modal&&(
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b flex justify-between items-center sticky top-0 bg-white rounded-t-2xl z-10">
              <h2 className="font-bold text-gray-800">{editId?"Editar":"Nova Demanda"}</h2>
              <button onClick={()=>setModal(false)} className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Título *</label>
                <input className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.title||""} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Título da demanda"/></div>
              <div>
                <div className="flex items-center justify-between mb-1">
                  <label className="text-sm font-medium text-gray-700">Descrição</label>
                  <button type="button" onClick={()=>descFileRef.current?.click()}
                    className="flex items-center gap-1.5 text-xs text-indigo-600 hover:text-indigo-800 font-medium bg-indigo-50 hover:bg-indigo-100 px-2.5 py-1 rounded-lg transition-colors">
                    📎 Anexar imagem
                  </button>
                  <input ref={descFileRef} type="file" accept="image/*" multiple className="hidden" onChange={handleDescFileUpload}/>
                </div>
                <textarea
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 resize-y"
                  rows={10} value={form.description||""}
                  onChange={e=>setForm({...form,description:e.target.value})}
                  onPaste={handleDescPaste}
                  placeholder="Descreva a demanda... (cole ou anexe imagens acima com Ctrl+V)"/>
                {/* previews de imagens */}
                {(form.descImages||[]).length>0&&(
                  <div className="mt-2 flex flex-wrap gap-2">
                    {(form.descImages||[]).map(img=>(
                      <div key={img.id} className="relative group">
                        <img src={img.url} alt={img.name||"imagem"} className="h-20 w-auto rounded-lg border object-cover"/>
                        {/* botões aparecem ao passar o mouse */}
                        <div className="absolute inset-0 bg-black/40 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-1.5">
                          <button type="button" onClick={()=>downloadDescImage(img)}
                            title="Baixar" className="w-7 h-7 bg-white/90 hover:bg-white rounded-full flex items-center justify-center text-gray-700 text-xs font-bold">
                            ⬇
                          </button>
                          <button type="button" onClick={()=>setForm(f=>({...f,descImages:(f.descImages||[]).filter(x=>x.id!==img.id)}))}
                            title="Remover" className="w-7 h-7 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white text-xs font-bold">
                            ×
                          </button>
                        </div>
                        {img.name&&<p className="text-[10px] text-gray-400 truncate max-w-[80px] mt-0.5 text-center">{img.name}</p>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Formato</label>
                <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.format||""} onChange={e=>setForm({...form,format:e.target.value})}>
                  <option value="">Selecionar...</option>
                  {data.formats.map(f=><option key={f} value={f}>{f}</option>)}
                </select></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Prazo</label>
                  <input type="date" className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.deadline||""} onChange={e=>setForm({...form,deadline:e.target.value})}/></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Urgência</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.priority||"media"} onChange={e=>setForm({...form,priority:e.target.value})}>
                    {Object.entries(PRIORITIES).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
                  </select></div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.status||"falta_arte"} onChange={e=>setForm({...form,status:e.target.value})}>
                    {STATUS_GROUPS.map(g=>(
                      <optgroup key={g.id} label={g.label}>
                        {Object.entries(STATUSES).filter(([,v])=>v.group===g.id).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
                      </optgroup>
                    ))}
                  </select></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Responsável</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.assignedTo||""} onChange={e=>setForm({...form,assignedTo:e.target.value})}>
                    <option value="">Selecionar...</option>
                    {data.employees.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
                  </select></div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Cliente</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.clientId||""} onChange={e=>setForm({...form,clientId:e.target.value,projectId:""})}>
                    <option value="">Selecionar...</option>
                    {data.clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                  </select></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Projeto</label>
                  <select className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300" value={form.projectId||""} onChange={e=>setForm({...form,projectId:e.target.value})}>
                    <option value="">Selecionar...</option>
                    {data.projects.filter(p=>!form.clientId||p.clientId===form.clientId).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                  </select></div>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="text-sm font-medium text-gray-700">Arquivos para Aprovação</label>
                  <button onClick={addFormFile} className="text-xs text-indigo-600 hover:text-indigo-800 font-medium bg-indigo-50 hover:bg-indigo-100 px-2.5 py-1 rounded-lg transition-colors">+ Adicionar arquivo</button>
                </div>
                {formFiles.length===0&&<p className="text-xs text-gray-400 italic">Nenhum arquivo adicionado.</p>}
                <div className="space-y-2">
                  {formFiles.map((f,i)=>(
                    <div key={f.id} className="flex gap-2 items-start border rounded-lg p-2 bg-slate-50">
                      <span className="text-xs text-gray-400 font-medium mt-2 w-4 flex-shrink-0">{i+1}.</span>
                      <div className="flex-1 space-y-1.5">
                        <input className="w-full border rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-300 bg-white" value={f.name} onChange={e=>updateFormFile(f.id,"name",e.target.value)} placeholder="Nome do arquivo (ex: Banner versão A)"/>
                        <input className="w-full border rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-300 bg-white" value={f.url} onChange={e=>updateFormFile(f.id,"url",e.target.value)} placeholder="Link do Google Drive"/>
                      </div>
                      <button onClick={()=>removeFormFile(f.id)} className="text-red-400 hover:text-red-600 text-sm mt-1.5 flex-shrink-0">✕</button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="px-6 py-4 border-t flex justify-end gap-3 sticky bottom-0 bg-white rounded-b-2xl">
              <button onClick={()=>setModal(false)} className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-50">Cancelar</button>
              <button onClick={saveDemand} className="px-5 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium">{editId?"Salvar":"Criar"}</button>
            </div>
          </div>
        </div>
      )}

      {approvalModal&&<RevModal demand={approvalModal} onClose={()=>setApprovalModal(null)} onSubmit={c=>doApproval(approvalModal.id,"revisao",c)}/>}
      {toast&&<div className={`fixed bottom-5 right-5 px-5 py-3 rounded-xl shadow-lg text-white text-sm font-medium z-50 ${toast.type==="info"?"bg-gray-700":toast.type==="warn"?"bg-orange-500":"bg-indigo-600"}`}>{toast.msg}</div>}
    </div>
  );
}

// ── ENTRY POINT ────────────────────────────────────────────
export default function AgencyApp() {
  const hash=window.location.hash;
  const m=hash.match(/^#ap:(.+)$/);
  if(m) return <ApprovalPage encoded={m[1]}/>;
  return <AuthenticatedAgencyApp/>;
}

function AuthenticatedAgencyApp() {
  const {user,loading,logout}=useAuth();
  if(loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><p className="text-gray-400 text-sm animate-pulse">Carregando...</p></div>;
  if(!user) return <Navigate to="/login" replace/>;
  return <AgencyMain isAdmin={user.role==="admin"} userId={user.id||user.uid||"user"} userName={user.name||user.email||"Usuário"} onLogout={logout}/>;
}
